import React, { useEffect, useState } from 'react';
import Bubble from '../Response/Bubble';
import MessageFeedback from '../MessageFeedback';
import ErrorBoundary from '../Response/ErrorBoundary';
import SuggestionChips from '../Response/SuggestionChips';
import { CurrentResponseContext } from '../../../../src/Utils/Contexts';
import { returnSaneURL } from '../../../Utils/getImg';
import { ResponseTypes } from '../Response/Constants';
import { TString } from '../Response/Utils';
import botLogo from '../../../../assets/imgs/shopify-bot.png';
import { loadStateSession } from '../../FlyfishComponents/flyfishutils/utils';
import styled from 'styled-components';
import Modal from '../../FlyfishComponents/Modal';
import Input from '../../FlyfishComponents/Input';
import Button from '../../FlyfishComponents/Button';

interface Props {
	userQuery;
	handleSubmit: Function;
	selectedTheme: string;
	selectedButton: any;
	recommendationHeading: string;
	showOnHover: string;
	reason: any;
	getProductDescription: Function;
	createCart: Function;
	getProductDetails: Function;
	getCartId: Function;
	makePayment: Function;
	chatMessages: any[];
	quickLinks: any;
	data: any;
	extraDisambInformation?: any;
	isCampaignWorkflowTriggered: boolean;
	showError: Function;
	toggleLoginScreen: Function;
	botImageCheck: boolean;
	coverImageCheck: boolean;
	coverImage: any;
	popUpSnackBar: Function;
	voiceResponse: boolean;
	langCode: string;
	flyFishChangesReq: boolean;
	channel: string;
	chatInput: string;
	addUserResponse: Function;
	addServerMessage: Function;
	handlePaymentStatus: Function;
	paymentStatus;
	colorMode?: string;
	selectedColor?: string;
	colorScale?: string[];
	logoImagePath: Function;
	WorkflowData: any;
	token: string;
	botId: string;
	tenantId: any;
	conversationId: string;
	openThumbsPopup: Function;
	thumbFilledUp: boolean;
	productCarousel: boolean;
	showForm: boolean;
	handleSelectedProduct?: any;
	enableStyleAdvisor: any;
	advisorTitle: any;
	staticDetailsURL: any;
}
const UserResponse = (props: any) => {
	const { message, messageType, timeStamp, mainIndex, selectedTheme } = props;
	return (
		<div
			className={`msg-wrapper msg-${messageType}-wrapper ${selectedTheme}`}
			style={{ marginTop: mainIndex === 1 ? '52px' : '' }}
		>
			<div
				className={`msg-${messageType}-outer ${selectedTheme}  ${
					props.data.colorMode === 'dark' ? 'msg-dark' : 'msg-light'
				}`}
			>
				{props.channel === 'whatsapp' ? (
					<div className={`whatsApp-msg-${messageType} `}>
						<div
							className={`whatsApp-${messageType}-text whatsApp-text`}
							dangerouslySetInnerHTML={{ __html: message }}
						/>
						{
							<div className={`whatsApp-msg-${messageType}-timeline`}>
								<p className='whatsApp-time'>{timeStamp}</p>
								<img
									src={
										'https://dev.flyfish.ai/chatsdk/v1/images/message-delivery-iconb0820080ede8420e6467fadcbc7672b8.svg'
									}
									alt=''
								/>
							</div>
						}
					</div>
				) : (
					<div className={`msg-${messageType}`}>
						<div dangerouslySetInnerHTML={{ __html: message }} />
					</div>
				)}

				{props.channel === 'whatsapp' ? (
					<></>
				) : loadStateSession('selectedTheme') === 'monaco' ||
				  loadStateSession('selectedTheme') === 'E-commerce Chat' ? (
					<></>
				) : (
					<MessageFeedback
						messageType={messageType}
						timeStamp={timeStamp}
						popUpSnackBar={props.popUpSnackBar}
						openThumbsPopup={props.openThumbsPopup}
						thumbFilledUp={props.thumbFilledUp}
						handleSubmit={props.handleSubmit}
						selectedTheme={selectedTheme}
					/>
				)}
			</div>
		</div>
	);
};
const ServerResponse = (props: any) => {
	const {
		message,
		messageType,
		suggestions,
		searchStatus,
		messageKey,
		configData,
		workflowFlag,
		diagnosticInfo,
		extraDisambInformation,
		timeStamp,
		shouldDisableActions,
		serverResponseIndex,
		handleSubmit,
		triggerOauth,
		getProductDetails,
		getCartId,
		makePayment,
		createCart,
		promptLogin,
		suggestionChips,
		toggleLoginScreen,
		showError,
		mainIndex,
		maxIndex,
		showFeedbackIcons,
		isInsideCampaign,
		voiceResponse,
		langCode,
		colorScale,
		addUserResponse,
		addServerMessage,
		handlePaymentStatus,
		paymentStatus,
		channel,
		chatInput,
		logoImagePath,
		colorMode,
		token,
		WorkflowData,
		botId,
		tenantId,
		conversationId,
		openThumbsPopup,
		thumbFilledUp,
		productCarousel,
		showForm,
		handleSelectedProduct,
		reason,
		selectedColor,
		getProductDescription,
		selectedTheme,
		selectedButton,
		recommendationHeading,
		showOnHover,
		userQuery,
		advisorTitle,
		enableStyleAdvisor,
		staticDetailsURL,
	} = props;

	if (message && message.indexOf(`<div class='sf-preloader-img'>`) !== -1) {
		return (
			<div
				className='msg-wrapper msg-server-wrapper loader'
				style={{
					fontFamily: 'var(--fontFamily)',
				}}
				key={Date.now()}
			>
				<div className='msg-server-outer preloader'>
					{props.botImageCheck ? (
						<div className={'preview-image-holder'}>
							<img
								src={
									props.logoImagePath.length > 0
										? returnSaneURL(props.logoImagePath)
										: botLogo
								}
								alt={TString({ labelName: 'botAvatarLabel' })}
							/>
						</div>
					) : null}
					<div className='msg-server preloader'>
						<div>
							<div className={`pre-loader-body `}>
								<div className='pre-loader-dots one' />
								<div className='pre-loader-dots two' />
								<div className='pre-loader-dots three' />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<>
			<div className='ff-message-feather'>
				{message.map((eachBubble, index) => {
					const isRichMultiElement =
						eachBubble.isRichElement &&
						eachBubble.listResponseType &&
						eachBubble.listResponseType.indexOf('MULTI') === 0;
					return (
						<div className='ff-msg-wrapper' key={`msg-wrapper-${index}`}>
							{searchStatus !== 2 ? (
								<div
									className={`msg-wrapper msg-${messageType}-wrapper `}
									style={{
										margin:
											eachBubble.responseType === ResponseTypes.CARD
												? '12px 0'
												: '',

										fontFamily: 'var(--fontFamily)',
									}}
								>
									{props.channel === 'whatsapp' &&
									((!eachBubble.isRatingTask &&
									serverResponseIndex > 0 &&
									message.length - 1 === index
										? suggestionChips && suggestionChips.length > 0
											? true
											: searchStatus === 3 &&
											  configData.quickLinksOnError === 'true'
											? true
											: false
										: false) ||
										((configData.isBotFrozen === 'true'
											? false
											: serverResponseIndex === 0
											? true
											: false) &&
											(configData.quicklinks.length > 0 &&
											JSON.parse(configData.quicklinks).length > 0
												? true
												: false))) ? null : (
										<>
											{eachBubble.isRichElement ||
											eachBubble.listResponseType ||
											eachBubble.responseType === ResponseTypes.TABLE ? (
												<div
													className={`msg-${messageType}-outer ${
														eachBubble.isRichElement &&
														props.channel !== 'whatsapp'
															? ''
															: ''
													} ${
														message.length - 1 === index
															? `no-margin-bottom ${
																	eachBubble.displayResponse.indexOf(
																		'carouselchoice'
																	) > -1
																		? 'ff-product-parent'
																		: ''
															  }`
															: ''
													}`}
												>
													<CurrentResponseContext.Consumer>
														{(val) => (
															<>
																<Bubble
																	advisorTitle={advisorTitle}
																	enableStyleAdvisor={enableStyleAdvisor}
																	staticDetailsURL={staticDetailsURL}
																	userQuery={userQuery}
																	selectedTheme={selectedTheme}
																	selectedButton={selectedButton}
																	recommendationHeading={recommendationHeading}
																	showOnHover={showOnHover}
																	reason={reason}
																	getProductDescription={getProductDescription}
																	productCarousel={productCarousel}
																	handleSelectedProduct={handleSelectedProduct}
																	colorScale={colorScale}
																	index={index}
																	lengthArray={message.length - 1}
																	data={eachBubble}
																	suggestions={suggestions}
																	searchStatus={searchStatus}
																	getProductDetails={getProductDetails}
																	getCartId={getCartId}
																	makePayment={makePayment}
																	createCart={createCart}
																	handleSubmit={handleSubmit}
																	shouldDisableActions={shouldDisableActions}
																	configData={configData}
																	showError={showError}
																	setResponseType={val.setType}
																	triggerOauth={triggerOauth || ''}
																	promptLogin={promptLogin || ''}
																	toggleLoginScreen={toggleLoginScreen}
																	isInsideCampaign={isInsideCampaign}
																	ResponseTypes={ResponseTypes}
																	botImageCheck={props.botImageCheck}
																	logoImagePath={
																		props.logoImagePath.length > 0
																			? props.logoImagePath
																			: botLogo
																	}
																	popUpSnackBar={props.popUpSnackBar}
																	voiceResponse={voiceResponse}
																	langCode={langCode}
																	flyFishChangesReq={
																		props.configData.flyFishChangesReq
																	}
																	timeStamp={timeStamp}
																	channel={channel}
																	chatInput={props.chatInput}
																	taskName={props.taskName}
																	addUserResponse={addUserResponse}
																	addServerMessage={addServerMessage}
																	handlePaymentStatus={handlePaymentStatus}
																	paymentStatus={paymentStatus}
																	WorkflowData={WorkflowData}
																	colorMode={colorMode}
																	selectedColor={selectedColor}
																	token={token}
																	botId={botId}
																	tenantId={tenantId}
																	conversationId={conversationId}
																	mainIndex={mainIndex}
																	maxIndex={maxIndex}
																/>
																{((index == 0 && message.length == 1) ||
																	(index == 0 &&
																		message.length > 1 &&
																		message[index + 1].displayResponse.indexOf(
																			'carouselchoice'
																		) <= -1) ||
																	eachBubble.displayResponse.indexOf(
																		'carouselchoice'
																	) > -1) &&
																	loadStateSession('selectedTheme') !==
																		'monaco' &&
																	loadStateSession('selectedTheme') !==
																		'E-commerce Chat' && (
																		<MessageFeedback
																			productCarousel={
																				eachBubble.displayResponse.indexOf(
																					'carouselchoice'
																				) > -1
																					? true
																					: false
																			}
																			showForm={showForm}
																			searchStatus={searchStatus}
																			data={configData}
																			messageType={messageType}
																			extraDisambInformation={
																				extraDisambInformation
																			}
																			diagnosticInfo={diagnosticInfo}
																			timeStamp={timeStamp}
																			workflowFlag={workflowFlag}
																			messageKey={messageKey}
																			popUpSnackBar={props.popUpSnackBar}
																			showFeedbackIcons={showFeedbackIcons}
																			voiceResponse={voiceResponse}
																			openThumbsPopup={openThumbsPopup}
																			thumbFilledUp={thumbFilledUp}
																			messageId={eachBubble.messageId}
																			multiChoice={
																				eachBubble.displayResponse.indexOf(
																					'carouselchoice'
																				) > -1
																					? eachBubble.lists
																					: []
																			}
																			colorMode={colorMode}
																			colorScale={colorScale}
																			selectedTheme={selectedTheme}
																		/>
																	)}
															</>
														)}
													</CurrentResponseContext.Consumer>
												</div>
											) : (
												<div className={`msg-${messageType}-outer`}>
													{props.botImageCheck && index == 0 ? (
														<div className={'preview-image-holder'}>
															<img
																src={
																	props.logoImagePath.length > 0
																		? returnSaneURL(props.logoImagePath)
																		: botLogo
																}
																alt={TString({ labelName: 'botAvatarLabel' })}
															/>
														</div>
													) : null}
													<div
														tabIndex={
															voiceResponse ||
															eachBubble.isRatingTask ||
															shouldDisableActions
																? -1
																: 0
														}
														className={`msg-${messageType} ${selectedTheme}
                      ${
												eachBubble.responseType === ResponseTypes.SIMPLE &&
												eachBubble.isMultiIntent
													? 'related-wrapper'
													: eachBubble.displayResponse.indexOf('JSONSplitter') >
													  -1
													? 'no-background-server'
													: ''
											}
                   ${
											eachBubble.listResponseType === 'MULTICHOICE' ||
											eachBubble.displayResponse.indexOf(
												'"apiType":"product_search"'
											) > -1
												? eachBubble.displayResponse.indexOf('"data":[]') > -1
													? ''
													: 'no-background-server'
												: ''
										} ${
															eachBubble.responseType === 'TABLE'
																? 'sf-less-padding'
																: ''
														} ${
															isRichMultiElement ? 'no-background-server' : ''
														} ${
															eachBubble.isRatingTask &&
															shouldDisableActions &&
															channel !== 'whatsapp'
																? 'action-disabled'
																: ''
														} ${
															props.channel === 'whatsapp'
																? eachBubble.listResponseType === 'MULTICHOICE'
																	? 'no-whatsapp-background-server'
																	: 'msg-server-whatsapp'
																: ''
														}`}
													>
														<CurrentResponseContext.Consumer>
															{(val) => (
																<>
																	<Bubble
																		advisorTitle={advisorTitle}
																		staticDetailsURL={staticDetailsURL}
																		enableStyleAdvisor={enableStyleAdvisor}
																		userQuery={userQuery}
																		selectedTheme={selectedTheme}
																		selectedButton={selectedButton}
																		recommendationHeading={
																			recommendationHeading
																		}
																		showOnHover={showOnHover}
																		reason={reason}
																		getProductDescription={
																			getProductDescription
																		}
																		handleSelectedProduct={
																			handleSelectedProduct
																		}
																		productCarousel={productCarousel}
																		colorScale={colorScale}
																		index={index}
																		lengthArray={message.length - 1}
																		data={eachBubble}
																		suggestions={suggestions}
																		searchStatus={searchStatus}
																		handleSubmit={handleSubmit}
																		getProductDetails={getProductDetails}
																		getCartId={getCartId}
																		makePayment={makePayment}
																		createCart={createCart}
																		shouldDisableActions={shouldDisableActions}
																		configData={configData}
																		showError={showError}
																		setResponseType={val.setType}
																		triggerOauth={triggerOauth || ''}
																		promptLogin={promptLogin || ''}
																		toggleLoginScreen={toggleLoginScreen}
																		ResponseTypes={ResponseTypes}
																		popUpSnackBar={props.popUpSnackBar}
																		voiceResponse={voiceResponse}
																		langCode={langCode}
																		flyFishChangesReq={
																			props.configData.flyFishChangesReq
																		}
																		timeStamp={timeStamp}
																		channel={channel}
																		taskName={props.taskName}
																		addUserResponse={addUserResponse}
																		addServerMessage={addServerMessage}
																		handlePaymentStatus={handlePaymentStatus}
																		paymentStatus={paymentStatus}
																		chatInput={chatInput}
																		WorkflowData={WorkflowData}
																		colorMode={colorMode}
																		selectedColor={selectedColor}
																		token={token}
																		botId={botId}
																		tenantId={tenantId}
																		conversationId={conversationId}
																		mainIndex={mainIndex}
																		maxIndex={maxIndex}
																	/>
																</>
															)}
														</CurrentResponseContext.Consumer>
													</div>
													{((index == 0 && message.length == 1) ||
														(index == 0 &&
															message.length > 1 &&
															message[index + 1].displayResponse.indexOf(
																'carouselchoice'
															) <= -1) ||
														eachBubble.displayResponse.indexOf(
															'carouselchoice'
														) > -1) &&
														loadStateSession('selectedTheme') !== 'monaco' &&
														loadStateSession('selectedTheme') !==
															'E-commerce Chat' && (
															<MessageFeedback
																productCarousel={
																	eachBubble.displayResponse.indexOf(
																		'carouselchoice'
																	) > -1
																		? true
																		: false
																}
																showForm={showForm}
																searchStatus={searchStatus}
																data={configData}
																messageType={messageType}
																extraDisambInformation={extraDisambInformation}
																diagnosticInfo={diagnosticInfo}
																timeStamp={timeStamp}
																workflowFlag={workflowFlag}
																messageKey={messageKey}
																popUpSnackBar={props.popUpSnackBar}
																showFeedbackIcons={showFeedbackIcons}
																voiceResponse={voiceResponse}
																openThumbsPopup={openThumbsPopup}
																thumbFilledUp={thumbFilledUp}
																messageId={eachBubble.messageId}
																handleSubmit={handleSubmit}
																selectedTheme={selectedTheme}
															/>
														)}
												</div>
											)}
										</>
									)}

									{!eachBubble.isRatingTask &&
									serverResponseIndex > 0 &&
									message.length - 1 === index ? (
										<>
											{suggestionChips && suggestionChips.length > 0 ? (
												<div
													className={
														channel === 'whatsapp'
															? 'sf-whatsapp-quicklink-wrapper'
															: 'suggestion-chips-div'
													}
												>
													<SuggestionChips
														data={suggestionChips}
														voiceResponse={voiceResponse}
														channel={channel}
														botMessage={eachBubble.displayResponse}
														handleSubmit={handleSubmit}
														timeStamp={timeStamp}
														addUserResponse={addUserResponse}
														shouldDisableActions={shouldDisableActions}
														type={'suggestionchips'}
														dataV={props.data}
													/>
												</div>
											) : searchStatus === 3 &&
											  configData.quickLinksOnError === 'true' ? (
												<div
													className={
														channel === 'whatsapp'
															? configData.quicklinks.length > 0 &&
															  JSON.parse(configData.quicklinks).length > 0
																? 'sf-whatsapp-quicklink-wrapper'
																: ''
															: 'sf-quicklink-wrapper'
													}
												>
													{
														<SuggestionChips
															index={index}
															data={
																configData.quicklinks.length > 0 &&
																JSON.parse(configData.quicklinks)
															}
															voiceResponse={voiceResponse}
															channel={channel}
															botMessage={eachBubble.displayResponse}
															handleSubmit={handleSubmit}
															timeStamp={timeStamp}
															addUserResponse={addUserResponse}
															shouldDisableActions={shouldDisableActions}
															type={'quicklinks'}
															dataV={props.data}
														/>
													}
												</div>
											) : null}
										</>
									) : null}
								</div>
							) : null}
							{configData.isBotFrozen ===
							'true' ? null : serverResponseIndex === 0 ? (
								<div
									className={
										channel === 'whatsapp'
											? configData.quicklinks.length > 0 &&
											  JSON.parse(configData.quicklinks).length > 0
												? 'sf-whatsapp-quicklink-wrapper'
												: ''
											: 'sf-quicklink-wrapper'
									}
								>
									{
										<SuggestionChips
											index={index}
											data={
												configData.quicklinks.length > 0 &&
												configData.quicklinks
											}
											voiceResponse={voiceResponse}
											channel={channel}
											botMessage={eachBubble.displayResponse}
											handleSubmit={handleSubmit}
											timeStamp={timeStamp}
											addUserResponse={addUserResponse}
											shouldDisableActions={shouldDisableActions}
											type={'quicklinks'}
											dataV={props.data}
										/>
									}
								</div>
							) : null}
						</div>
					);
				})}
			</div>
		</>
	);
};

class MessageFeather extends React.Component<Props, null> {
	constructor(props) {
		super(props);
	}
	componentDidUpdate(prevProps: any) {
		if (this.props.chatMessages !== prevProps.chatMessages) {
		}
	}

	render() {
		return (
			<React.Fragment>
				{this.props.channel === 'whatsapp' ? (
					<div className='secure-message-showup'>
						<p className='secure-key-message' style={{ margin: '0' }}>
							<span className='message'>
								Type something here to test what your users will see when they
								interact with your After Sales Support
							</span>
						</p>
					</div>
				) : null}

				<div className='sfchatbot-message-bubbles'>
					{this.props.chatMessages
						? this.props.chatMessages.map((eachChatMessage, index) => {
								if (index === 1 && this.props.isCampaignWorkflowTriggered)
									return;

								const messageType = eachChatMessage.messageType;
								const shouldDisableActions =
									true &&
									index > 0 &&
									index < this.props.chatMessages.length - 1;
								const isLoader =
									eachChatMessage.message &&
									eachChatMessage.message.indexOf(
										`<div class='sf-preloader-img'>`
									) !== -1;
								return this.props.channel === 'whatsapp' &&
									eachChatMessage.message[0].displayResponse ===
										'whatsapp' ? null : (
									<React.Fragment key={index + 'message-feather'}>
										{messageType === 'user' ? (
											<ErrorBoundary langCode={this.props.langCode}>
												<UserResponse
													{...eachChatMessage}
													botImageCheck={this.props.botImageCheck}
													popUpSnackBar={this.props.popUpSnackBar}
													mainIndex={index}
													channel={this.props.channel}
													data={this.props.data}
													selectedTheme={this.props.selectedTheme}
												/>
											</ErrorBoundary>
										) : (
											<ErrorBoundary
												botImageCheck={this.props.botImageCheck}
												lastMessage={
													index === this.props.chatMessages.length - 1
												}
												logoImagePath={this.props.data.logoImagePath}
												langCode={this.props.langCode}
												channel={this.props.channel}
												timeStamp={eachChatMessage.timeStamp}
											>
												<div className={`${isLoader ? 'loader' : ''}`}>
													<ServerResponse
														{...eachChatMessage}
														messageKey={eachChatMessage.key}
														enableStyleAdvisor={this.props.enableStyleAdvisor}
														staticDetailsURL={this.props.staticDetailsURL}
														advisorTitle={this.props.advisorTitle}
														reason={this.props.reason}
														userQuery={this.props.userQuery}
														getProductDescription={
															this.props.getProductDescription
														}
														productCarousel={this.props.productCarousel}
														showForm={this.props.showForm}
														handleSelectedProduct={
															this.props.handleSelectedProduct
														}
														configData={this.props.data}
														shouldDisableActions={shouldDisableActions}
														serverResponseIndex={index}
														handleSubmit={this.props.handleSubmit}
														getProductDetails={this.props.getProductDetails}
														getCartId={this.props.getCartId}
														makePayment={this.props.makePayment}
														createCart={this.props.createCart}
														showError={this.props.showError}
														toggleLoginScreen={this.props.toggleLoginScreen}
														logoImagePath={this.props.data.logoImagePath}
														botImageCheck={this.props.botImageCheck}
														mainIndex={index}
														isInsideCampaign={this.props.data.isInsideCampaign}
														popUpSnackBar={this.props.popUpSnackBar}
														maxIndex={this.props.chatMessages.length - 1}
														voiceResponse={this.props.voiceResponse}
														langCode={this.props.langCode}
														colorScale={this.props.colorScale}
														channel={this.props.channel}
														addUserResponse={this.props.addUserResponse}
														addServerMessage={this.props.addServerMessage}
														handlePaymentStatus={this.props.handlePaymentStatus}
														paymentStatus={this.props.paymentStatus}
														chatInput={this.props.chatInput}
														data={this.props.data}
														WorkflowData={this.props.WorkflowData}
														colorMode={this.props.colorMode}
														selectedColor={this.props.selectedColor}
														token={this.props.token}
														botId={this.props.botId}
														tenantId={this.props.tenantId}
														conversationId={this.props.conversationId}
														openThumbsPopup={this.props.openThumbsPopup}
														selectedTheme={this.props.selectedTheme}
														selectedButton={this.props.selectedButton}
														showOnHover={this.props.showOnHover}
														recommendationHeading={
															this.props.recommendationHeading
														}
														//	thumbFilledUp={this.props.thumbFilledUp}
													/>
												</div>
											</ErrorBoundary>
										)}
									</React.Fragment>
								);
						  })
						: null}
				</div>
			</React.Fragment>
		);
	}
}

export default MessageFeather;
